import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-email",
  "use": "icon-email-usage",
  "viewBox": "0 0 1365 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1365 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-email\"><path d=\"M684 607.733 1282.007 9.728A133.077 133.077 0 0 0 1232.001 0H133.334c-16.939 0-33.205 3.2-48.139 8.939l598.806 598.794z\" /><path d=\"M684 728.395 19.468 63.86A132.48 132.48 0 0 0 .001 133.333v757.334C0 964.267 59.734 1024 133.334 1024h1098.667c73.6 0 133.333-59.733 133.333-133.333V133.333a133.013 133.013 0 0 0-18.528-67.733L684.001 728.395z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol